(() => {
  if (window.lcsCardSpinPreview) return;
  window.lcsCardSpinPreview = true;
  const states = new WeakMap();
  const cache = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = null;
  function load(src) {
    if (cache.has(src)) return cache.get(src);
    const promise = new Promise(resolve => {
      const image = new Image();
      let finished = false;
      const done = value => {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        image.onload = image.onerror = null;
        resolve(value);
      };
      const timeout = setTimeout(() => done(null), 8000);
      image.fetchPriority = 'low';
      image.onload = async () => {
        try { await image.decode(); done(image.naturalWidth ? image : null); }
        catch (_) { done(null); }
      };
      image.onerror = () => done(null);
      image.src = src;
    });
    cache.set(src, promise);
    while (cache.size > 48) cache.delete(cache.keys().next().value);
    promise.then(image => { if (!image && cache.get(src) === promise) cache.delete(src); });
    return promise;
  }
  function reset(state) {
    state.run++;
    clearTimeout(state.timer);
    state.timer = null;
    state.image.src = state.original;
    if (state.srcset !== null) state.image.setAttribute('srcset', state.srcset);
    state.card.removeAttribute('data-lcs-spin-playing');
    if (active === state) active = null;
  }
  async function enter(card) {
    if (reduced.matches) return;
    let state = states.get(card);
    if (!state) {
      const image = card.querySelector('.card__media img');
      let frames;
      try { frames = JSON.parse(card.querySelector('[data-lcs-card-spin-frames]').textContent); } catch (_) { return; }
      if (!image || !Array.isArray(frames) || frames.length !== 8) return;
      state = { card, image, frames, run: 0, timer: null };
      states.set(card, state);
    }
    if (active === state) return;
    if (active) reset(active);
    state.original = state.image.getAttribute('src');
    state.srcset = state.image.getAttribute('srcset');
    active = state;
    const run = ++state.run;
    // Decode only this card's eight small frames, never every collection item.
    const images = await Promise.all(state.frames.map(load));
    if (run !== state.run || active !== state || !card.isConnected) return;
    if (images.some(image => !image) || reduced.matches || document.hidden) { reset(state); return; }
    state.image.removeAttribute('srcset');
    card.setAttribute('data-lcs-spin-playing', '');
    let index = 0;
    const step = () => {
      if (run !== state.run || active !== state) return;
      if (!card.isConnected || document.hidden || reduced.matches || index >= 8) { reset(state); return; }
      state.image.src = state.frames[index++];
      state.timer = setTimeout(step, 110);
    };
    step();
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target.closest?.('[data-lcs-card-spin]');
    if (card && !card.contains(event.relatedTarget)) enter(card);
  });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest?.('[data-lcs-card-spin]');
    if (card && !card.contains(event.relatedTarget)) {
      const state = states.get(card);
      if (state && active === state) reset(state);
    }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden && active) reset(active); });
  reduced.addEventListener('change', () => { if (reduced.matches && active) reset(active); });
})();
